import '../i18n/config.ts';
import { ApolloProvider } from '@apollo/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AuthProvider, ThemeProvider } from 'shared/components';
import { client } from 'shared/components/ApolloClient';
import { Survey } from './Survey/Survey';
import { DefaultPage } from './DefaultPage/DefaultPage';
import SurveyErrorPage from './SurveyErrorPage/SurveyErrorPage';
import { ErrorPage } from './ErrorPage/ErrorPage';

export const App = (): JSX.Element => {
    const location = window.location.hostname;
    const customHosts = JSON.parse(process.env.CUSTOM_HOSTS || '{}');
    const isCustomHost = Object.keys(customHosts).includes(location);

    const routes = isCustomHost ? (
        <Routes>
            <Route
                path="quick-check/"
                element={
                    <Survey
                        partnerId={customHosts[location]['pid']}
                        showSalutation={customHosts[location]['show_survey_salutation']}
                    />
                }
            />
            <Route path="*" element={<SurveyErrorPage />} />
        </Routes>
    ) : (
        <Routes>
            <Route path="quick-check/:partnerId" element={<Survey />} />
            {/* <Route path="quick-check/" element={<SurveyErrorPage />} />
            <Route path="*" element={<DefaultPage />} /> */}
            <Route path="quick-check/" element={<SurveyErrorPage />} />
            <Route path="*" element={<ErrorPage error="Page not found" />} />
        </Routes>
    );

    return (
        <ApolloProvider client={client}>
            <AuthProvider>
                <ThemeProvider>
                    <BrowserRouter>{routes}</BrowserRouter>
                </ThemeProvider>
            </AuthProvider>
        </ApolloProvider>
    );
};
